"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.letterSpacings=exports.lineHeights=exports.fontWeights=exports.fontSizes=exports.fontFamilies=exports.font=exports.fonts=void 0;var fonts={Ambra:"'Ambra', 'Helvetica Neue', Helvetica, Arial, sans-serif",heading:"inherit"};exports.fonts=fonts;var font=fonts.Ambra;exports.font=font;var fontFamilies=fonts;exports.fontFamilies=fontFamilies;var fontSizes=["0.625rem",// 0
"0.75rem",// 1
"0.875rem",// 2
"1rem",// 3
"1.125rem",// 4
"1.25rem",// 5
"1.375rem",// 6
"1.5rem",// 7
"1.75rem",// 8
"2rem",// 9
"2.25rem",// 10
"2.5rem",// 11
"2.75rem",// 12
"3rem",// 13
"3.25rem",// 14
"3.5rem",// 15
"3.75rem",// 16
"4rem",// 17
"4.25rem",// 18
"4.5rem",// 19
"4.75rem",// 20
"5rem",// 21
"5.25rem",// 22
"5.5rem",// 23
"5.75rem",// 24
"6rem"// 25
];exports.fontSizes=fontSizes;var fontWeights=[300,400,500,700];exports.fontWeights=fontWeights;var lineHeights=["0.875rem",// 0
"1rem",// 1
"1.125rem",// 2
"1.25rem",// 3
"1.5rem",// 4
"1.75rem",// 5
"2.25rem",// 6
"2.50rem",// 7
"3.5rem",// 8
"4.5rem",// 9
"3rem",// 10
"2rem"// 11
];exports.lineHeights=lineHeights;var letterSpacings=[1.6,1.2,-.2,1,2];exports.letterSpacings=letterSpacings;